import React, { useState } from "react";
import { Grid, Icon, Loader } from "semantic-ui-react";
import InputField from "../../../commonComponents/formComponents/inputField";
import DropDown from "../../../commonComponents/formComponents/dropDown";

import {
  deleteHeaderAIStatementAndCodeInfo,
  updateHeaderAIStatementInfoFeilds,
  saveAIInfoFeilds,
} from "../../actions";
import { useSelector, useDispatch } from "react-redux";
import { getDropDownInputText } from "../../../Helper";
function SupplyChainActorDetails(props){
  const [isRemoving, setIsRemoving] = useState(false);
  const dispatch = useDispatch();

  const aiCodeList = useSelector((state) =>
    state.Shipment.declarationType === "IM"
      ? state.DropDownValues.aiCodeListHeaderIm
      : state.Shipment.declarationType === "EX"
      ? state.DropDownValues.aiCodeListHeaderEx
      : null
  );
  const info = useSelector(
    (state) => state.Shipment.aiStatementUkInfo[props.infoIndex]
  );

  const updateRemoveFlag = () => {
    setIsRemoving(false);
  };

  const { infoIndex, totalInfo, isFormEnabled } = props;
  const isFormDisabled = isFormEnabled === false;
  return (
    <Grid.Row>
      <Grid.Column
        width="5"
        className="divFormFeild border-bottom  b-blr-5 b-rw-0"
      >
        <DropDown
          id={`code-Header-${infoIndex}-headeraicodeandStatements`}
          label={"ROLE"}
          boxNumber="44"
          disabled={isFormDisabled}
          className="field-bg dropdown100"
          labelClass="text-none"
          isLabel={true}
          data={aiCodeList}
          text={getDropDownInputText(info.code, aiCodeList) || "SELECT"}
          onChange={(value) => {
            dispatch(
              updateHeaderAIStatementInfoFeilds(infoIndex, "code", value)
            );

          }}
          onBlur={(value) => {
            dispatch(saveAIInfoFeilds(infoIndex, "code"));
          }}
        />
      </Grid.Column>
      <Grid.Column
        width="5"
        className="divFormFeild  border-bottom  b-rw-0 "
      >
        <InputField
          isLabel={false}
          id={`ref-Header-${infoIndex}-headeraicodeandStatements`}
          type="text"
          label="INDENTIFICATION"
          value={info.ref}
          className={"field-bg"}
          clearInput={false}
          onChange={(value) => {
            dispatch(
              updateHeaderAIStatementInfoFeilds(infoIndex, "ref", value)
            );

          }}
          onBlur={(value) => {
            dispatch(saveAIInfoFeilds(infoIndex, "ref"));
          }}
          disabled={isFormDisabled}
        />
      </Grid.Column>
      <Grid.Column
        width="5"
        className="divFormFeild border-bottom b-brr-5 b-trr-5"
      >
        <DropDown
          id={`code-Header-${infoIndex}-headeraicodeandStatements`}
          label={"OWNER"}
          boxNumber="44"
          disabled={isFormDisabled}
          className="field-bg dropdown100"
          labelClass="text-none"
          isLabel={true}
          data={aiCodeList}
          text={getDropDownInputText(info.code, aiCodeList) || "SELECT"}
          onChange={(value) => {
            dispatch(
              updateHeaderAIStatementInfoFeilds(infoIndex, "code", value)
            );

          }}
          onBlur={(value) => {
            dispatch(saveAIInfoFeilds(infoIndex, "code"));
          }}
        />
      </Grid.Column>
      <Grid.Column width="1" className="icon-delete-add-info">
        {!isRemoving ? (
          <span>
            {totalInfo > 0 && (
              <Icon
                name="trash alternate outline"
                onClick={() => {
                  setIsRemoving(true);
                  dispatch(
                    deleteHeaderAIStatementAndCodeInfo(
                      info.infoId,
                      infoIndex,
                      updateRemoveFlag
                    )
                  );
    
                }}
                disabled={isFormDisabled || isRemoving}
              />
            )}
          </span>
        ) : (
          <span className="delete-info-loader">
            <Loader active inline size="mini" style={{ marginRight: "10px" }} />
          </span>
        )}
      </Grid.Column>
    </Grid.Row>
  );
}

export default React.memo(SupplyChainActorDetails)
